import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`When the checkout is succefully complete, Drop-In Checkout displays a success scene with a default success message "Your payment was successful!".`}</p>
    <p>{`Set the option `}<inlineCode parentName="p">{`successScreen`}</inlineCode>{` to modify the default behavior of the success scene.`}</p>
    <p>{`Remove the success screen:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const options = {
    /* Other options ... */
    successScreen: false,
}
`}</code></pre>
    <p>{`Change the message of the default success screen:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const options = {
    /* Other options ... */
    successScreen: {
        type: 'CHECK',
        title: 'This is a custom success message!',
    },
}
`}</code></pre>
    <Group summary='Properties' open mdxType="Group">
	<Item title='type' subtitle='"CHECK"' mdxType="Item">
		"CHECK" is the only type of success screen supported at the moment.
	</Item>
	<Item title='title' subtitle='string' mdxType="Item">
		Your custom success message.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      